import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { AbstractMomentValidator } from './moment.abstract.validator';
import { Moment } from 'moment';

@Directive({
    selector: '[validateBefore][formControlName],[validateBefore][formControl],[validateBefore][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MomentBeforeValidator),
            multi: true
        }
    ],
    standalone: false
})
export class MomentBeforeValidator extends AbstractMomentValidator {
  constructor(@Attribute('validateBefore') public validateBefore: string) {
    super(validateBefore);
  }

  compareValues(a: Moment, b: Moment): { [key: string]: any } {
    if (!a.isBefore(b)) {
      return {
        validateBefore: true
      };
    }
    return null;
  }

  clearTargetErrors(e: any) {
    delete e.errors['validateBefore'];
  }
}
